const locale = {
  ACCOUNT_MENU_BUTTON_ARIA_LABEL: 'Menú de cuenta, {{name}}',
  GUEST_NAME: 'Invitado',
  PROFILE: 'Perfil',
  CHANGE_PASSWORD: 'Cambiar Contraseña',
  TWO_AUTHENTICATION: 'Configuración de seguridad (2FA)',
  LOGOUT: 'Salir',
  HOME: 'Recomendaciones',
  SKILLS: 'Habilidades',
  OCCUPATIONS: 'Objetivos Profesionales',
  LEARNING_PATHS: 'Rutas de Aprendizaje',
  COURSES: 'Cursos Guardados',
  HELP: 'Ayuda',
  PERSONAL: 'Información Personal',
  PREFERENCES: 'Preferencias',
};

export default locale;
